module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0085.jpg?v=818e9b2f";